<template>
  <div class="breadCrumbs">
    <div
      v-if="
        !getIsBreadCrumbsLoading &&
          getBreadCrumbs &&
          getBreadCrumbs.Items.length
      "
    >
      <span v-for="(item, index) in displayBreadcrumb" :key="index">
        <span
          :class="[
            {
              'clickable-breadcrumb': item.IsClickable,
              'first-breadcrumb': index === 0,
              bold: index === displayBreadcrumb.length - 1
            }
          ]"
        >
          <a v-if="item.IsClickable && index !== 0" :href="item.Url">
            {{ item.Title }}
          </a>
          <span v-else>
            {{ item.Title }}
          </span>
        </span>
        <span v-if="index < displayBreadcrumb.length - 1"> / </span>
      </span>
    </div>
    <div v-else>
      <Skeleton
        :loading="getIsBreadCrumbsLoading"
        width="60%"
        height="21px"
        marginBottom="0px"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Skeleton from "./ProductSkeleton.vue";
export default {
  name: "ProductBreadCrumbs",
  computed: {
    ...mapGetters("product", ["getBreadCrumbs", "getIsBreadCrumbsLoading"]),

    displayBreadcrumb() {
      const items = this.getBreadCrumbs?.Items || [];
      if (!items.length) return null;
      if (items.length <= 2) {
        return items;
      }
      return items.slice(0, 2);
    }
  },
  mounted() {

  },
  components: {
    Skeleton
  }
};
</script>

<style lang="scss" scoped>
.breadCrumbs {
  text-align: left;
  color: $primary;
  font-family: $body;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.4px;
  line-height: 21px;
  padding-bottom: 27px;

  a {
    text-decoration: none; // No underline by default
    color: inherit; // Inherit color from the parent element

    &:hover {
      text-decoration: underline;
    }
  }
}
.first-breadcrumb {
  color: gray;
  pointer-events: none; // Disable pointer events to make it non-clickable
  cursor: default; // Change cursor to default to indicate it's not clickable
}
</style>
